import React, { useEffect, useState } from "react";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import PropTypes from 'prop-types'; 
import '../Style/Layout.css';
import '../Style/Footer.css';
import { Link } from "react-router-dom";

import { useLocation } from 'react-router-dom'

import Sticky, { RenderPropSticky } from 'react-sticky-el';
import { useSelector, useDispatch} from 'react-redux'
import ContactUs from '../Components/ContactUs'

const DefaultLayout = ({children}) => {

  const { pathname } = useLocation();
  const { open } = useSelector(state => state.message)

  const [ navLink, setNavLink ] = useState([
      "/",
      "/careerinpoland",
      "/academy",
      "/recruitment",
      "/about-us",
      "/contact-us",
      "/terms-of-services", 
      "/privacy-policy", 

    ]);

  console.log(pathname, open);


  return (
  	<div className="AuthLayout.js">
        <div className='bg-light-gray'>
          <div className='d-none d-lg-block d-xl-block container'>
            <div className='row px-2 py-2'>

              <div className='col-10 d-flex align-items-center'>
                <a href="mail:krayr@krayr.com" className='top_bar-info_link'>
                  <i className="bi bi-geo-alt  top_bar-info"></i>
                  <span className="mx-2  text-sm top_bar-info">    
                    al.Solidarności 168/121 00-240 Warszawa
                  </span>
                </a>
                <a href="mail:krayr@krayr.com" className='mx-3 top_bar-info_link'>
                  <i className="bi bi-envelope-plus  top_bar-info"></i>
                  <span className="mx-2  text-sm top_bar-info">info@krayrpol.pl</span>
                </a>
              </div>

              <div className='col-2 d-flex justify-content-end align-items-center'>
                <Link to='/'><i className='mx-3 bi bi-facebook top_bar-icon'></i></Link>
                <Link to='/' className=' text-black'><i className='bi bi-instagram top_bar-icon'></i></Link>
              </div>

            </div>
          </div>
        </div>

        <Sticky>
          <Header/>
        </Sticky>

        { children }

        { navLink.includes(pathname) ? 
          <>
            <div className='bg-footerImage '>
              <Footer/>
            </div>
          </> : <>
            <div className="misc-bg-footerImage">
              <Footer/>
            </div>
          </>
        }

        
        
      </div>
  );
}

DefaultLayout.propTypes = {   
  children: PropTypes.element.isRequired, 
};

export default DefaultLayout;
